import React from 'react'
import { useSelector } from 'react-redux'
import { selectShowAmazonImport } from 'selectors/mainView'
import { MovableModalContainer } from 'components/MovableModal'
import AmazonImport from './AmazonImport'

export const AmazonImportContainer = () => {
  const isVisible = useSelector(selectShowAmazonImport)
  return (
    <MovableModalContainer
      visible={isVisible}
      width={512}
      height={300}
      withBackground
      windowId="AmazonImportContainer"
    >
      <AmazonImport />
    </MovableModalContainer>
  )
}
